import { Tab } from 'react-bootstrap'
import "./Profile_tabs_and_content.css"
import Bank_details_tab_content from './profile_all_contents/bank_details_tab_content/Bank_details_tab_content'
import Kyc_tab_content from './profile_all_contents/kyc_tab_content/Kyc_tab_content'
import Password_tab_content from './profile_all_contents/password_tab_content/Password_tab_content'
import Personal_details_tab_content from './profile_all_contents/personal_details_tab_content/Personal_details_tab_content'
import Profile_all_tabs from './profile_all_tabs/Profile_all_tabs'
function Profile_tabs_and_content() {
    return (
        <>
            <section className='profile_tabs_and_content '>
                <div className="container">
                    <Tab.Container id="left-tabs-example" defaultActiveKey="personal-details">
                        <div className="row">
                            <div className="col-md-3 col-sm-4 mb-3">
                                <div className="section_holder">
                                    <Profile_all_tabs />
                                </div>
                            </div>
                            <div className="col-md-9 col-sm-8 mb-3">
                                <div className="section_holder">
                                    <Tab.Content>
                                        <Tab.Pane eventKey="personal-details"><Personal_details_tab_content /></Tab.Pane>
                                        <Tab.Pane eventKey="password"><Password_tab_content /></Tab.Pane>
                                        <Tab.Pane eventKey="kyc"><Kyc_tab_content /></Tab.Pane>
                                        <Tab.Pane eventKey="bank-details"><Bank_details_tab_content /></Tab.Pane>
                                    </Tab.Content>
                                </div>
                            </div>
                        </div>
                    </Tab.Container>
                </div>
            </section>
        </>
    )
}

export default Profile_tabs_and_content